const rootApi = 'https://lumtwj.uc.r.appspot.com';
// const rootApi = 'http://localhost:3001';
export const TileApi = rootApi + '/tile';
export const TraceApi = rootApi + '/trace';
export const AddTileApi = TileApi + '/add';
export const NextPublicHolidayApi = rootApi + '/calendar/holiday/next';
